



















































import Verify from "vue2-verify";
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import vSelect from "../v-select.vue";
import service from "@/api/indexNew";

@Component({
    components: {
        vSelect,
        Verify,
    },
})
export default class extends Vue {
    private showMsg = false;
    private msg = "";
    private isSuccess = false;
    private imgData = "";
    private sendCode = false;
    private timer: any = null;
    private countdown = -1;
    private pars: any = {
        companyName: "",
        name: "",
        phone: "",
        phoneCode: "",
        randomCode: "",
        randomKey: 0,
        tenantId: "100000",
        source:'黑谷官网注册'
    };
    @Prop({
        default: false,
    })
    visible!: boolean;

    @Prop() phone!: string;

    @Watch("phone") watchPhone(phone: string) {
        this.pars.phone = phone;
    }

    @Emit("onClose") onClose() {
        return false;
    }
    mounted() {
        this.refreshImg();
    }
    refreshRandomImgKey() {
        this.pars.randomKey = Math.floor(Math.random() * 90000) + 10000;
    }
    refreshImg() {
        this.refreshRandomImgKey();
        const pars = {
            key: this.pars.randomKey,
            tenantId: this.pars.tenantId,
        };
        service
            .newCrmVerifyCode(pars)
            .then((res) => {
                console.log("refreshImg", res);
                this.imgData = res.data.result;
                console.log(this.imgData);
            })
            .catch((error) => {
                this.showToast(error.message);
            });
    }
    sendNoteCode() {
        if (!this.pars.randomCode) {
            alert("请先输入图形验证码");
            return;
        }
        if (!this.pars.phone) {
            alert("请输入手机号");
            return;
        }

        service
            .newCrmSmsVerifyCode(this.pars)
            .then(() => {
                this.sendCode = true;
                if (this.timer) clearInterval(this.timer);
                this.countdown = 59;
                this.timer = setInterval(() => {
                    console.log(this.sendCode, this.countdown);
                    if (this.countdown < 0) {
                        clearInterval(this.timer);
                        this.sendCode = false;
                    }
                    this.countdown = this.countdown - 1;
                }, 1000);
            })
            .catch((error) => {
                this.showToast(error.message);
                this.refreshImg();
            });
    }
    showToast(msg: any) {
        this.showMsg = true;
        this.msg = msg;
        setTimeout(() => {
            this.showMsg = false;
        }, 2000);
    }
    async submit() {
        if (!this.pars.companyName) {
            alert("请输入店铺名称");
            return;
        }
        if (!this.pars.name) {
            alert("请输入您的姓名");
            return;
        }
        if (!this.pars.phone) {
            alert("请输入手机号");
            return;
        }
        if (!this.pars.randomCode) {
            alert("请先输入图形验证码");
            return;
        }
        if (!this.pars.phoneCode) {
            alert("请输入验证码");
            return;
        }
        service
            .newCrmRegister(this.pars)
            .then(() => {
                alert("恭喜您，注册成功，稍后会有客服人员进行联系您！");
            })
            .catch((error) => {
                this.showToast(error.message);
            });
    }
}
